export default function isOnlyNumbers(value) {
  const numberRegex = /^[0-9]*$/g;
  return numberRegex.test(value);
}
